module.exports = __webpack_public_path__ + "static/media/tablet-free.2ae59d40.png";